import { Dispatch, Middleware, MiddlewareAPI } from 'redux';
import { LOCATION_CHANGED } from 'redux-little-router';

import { Action } from '../../actions';
import { State } from '../../typings/state';

import { RUM } from './RUM';

export const rumErrorCounterMiddleWare: Middleware<{}, State, Dispatch<Action>> = (
    store: MiddlewareAPI<Dispatch<Action>, State>
): ((next: Dispatch<Action>) => (action: Action) => Action) => (
    next: Dispatch<Action>
): ((action: Action) => Action) => {
    if (!RUM.isRumInited()) {
        return next;
    }

    return (action: Action): Action => {
        const oldState = store.getState();
        const result = next(action);
        const newState = store.getState();

        processAction(oldState as State, newState as State, action);

        return result;
    };
};

function getContextFromPath(path: string): string {
    const m = path.match(/^\/dna\/([^\/?]*)(?:[\/?]|$)/);
    return (m && m[1]) || 'index';
}

function processAction(oldState: State, newState: State, action: Action): void {
    switch (action.type) {
        case LOCATION_CHANGED:
            const newContext = getContextFromPath(newState.router.pathname);
            if (oldState.router.pathname !== newContext && Ya.Rum.updateErrors) {
                Ya.Rum.updateErrors({
                    page: newContext
                });
            }
            break;
        default:
            return;
    }
}
